/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

async function loadShipping() {
    let sku = document.querySelector("[data-sku]").getAttribute("data-sku");
    if(sku) {
        const response = await fetch(`https://api.tanstella.com.au/shipping/${sku}`); // Replace 'URL_TO_YOUR_API' with the actual API endpoint
        const e = await response.json();
        console.log(e);
        var shippingInfoLocation = document.querySelector("#shipping-info .product-form__info-content");
        shippingInfoLocation.innerHTML += "<table id='shipping-table'><tr><th>VIC</th><th>NSW</th><th>SA</th><th>QLD</th></tr><tr><td>" + (0 == e.VIC ? "Free" : e.VIC) + "</td><td>" + (0 == e.NSW ? "Free" : e.NSW) + "</td><td>" + (0 == e.SA ? "Free" : e.SA) + "</td><td>" + (0 == e.QLD ? "Free" : e.QLD) + "</td></tr><tr><th>TAS</th><th>WA</th><th>NT</th><th class='border-none'></th></tr><tr class='border-none'><td>" + (0 == e.TAS ? "Free" : e.TAS) + "</td><td>" + (0 == e.WA ? "Free" : e.WA) + "</td><td>" + (0 == e.NT ? "Free" : e.NT) + "</td><td class='border-none'></td></tr></table><p id='shipping-remote'>* For some remote areas, the fee may be different. Please use the <strong><a href='#shipping'>Shipping Estimator</a></strong> to get more accurate fee.</p>";
        shippingInfoLocation.classList.remove("loading");
    }
};

document.addEventListener("DOMContentLoaded", function(){
    loadShipping();
});